import React from 'react';
import { Box, Tooltip } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

// Import PNG assets
import visaIcon from '../assets/visa.png';
import mastercardIcon from '../assets/mastercard.png';
import amexIcon from '../assets/amex.png';
import discoverIcon from '../assets/discover.png';

interface PaymentIconProps {
  paymentMethod: string;
}

const PaymentLogoImage = ({ src, alt }: { src: string; alt: string }) => (
  <Box
    component="img"
    src={src}
    alt={alt}
    sx={{
      height: 32,
      width: 'auto',
      maxWidth: 48,
      objectFit: 'contain',
    }}
  />
);

const getPaymentConfig = (method: string) => {
  const normalized = method.toLowerCase().trim();

  if (normalized.includes('visa')) {
    return {
      name: 'Visa',
      logo: <PaymentLogoImage src={visaIcon} alt="Visa" />,
    };
  }

  if (normalized.includes('mastercard') || normalized.includes('master card')) {
    return {
      name: 'Mastercard',
      logo: <PaymentLogoImage src={mastercardIcon} alt="Mastercard" />,
    };
  }

  if (normalized.includes('amex') || normalized.includes('american express')) {
    return {
      name: 'Amex',
      logo: <PaymentLogoImage src={amexIcon} alt="American Express" />,
    };
  }

  if (normalized.includes('discover')) {
    return {
      name: 'Discover',
      logo: <PaymentLogoImage src={discoverIcon} alt="Discover" />,
    };
  }

  if (normalized.includes('cash')) {
    return {
      name: 'Cash',
      logo: <AttachMoneyIcon sx={{ color: '#4CAF50', fontSize: 32 }} />,
    };
  }

  // Default for unknown payment methods
  return {
    name: method,
    logo: <CreditCardIcon sx={{ color: '#757575', fontSize: 32 }} />,
  };
};

export const PaymentIcon: React.FC<PaymentIconProps> = ({ paymentMethod }) => {
  const config = getPaymentConfig(paymentMethod);

  return (
    <Tooltip title={config.name} arrow>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'help',
        }}
      >
        {config.logo}
      </Box>
    </Tooltip>
  );
};